import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/auth/Login.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/auth/Register.vue')
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    meta: { requiresAuth: true },
    component: () => import('../views/dashboard/Home.vue')
  },
  {
    path: '/dashboard/apps',
    name: 'Apps',
    meta: { requiresAuth: true },
    component: () => import('../views/dashboard/Apps.vue')
  },
  {
    path: '/dashboard/settings',
    name: 'Settings',
    meta: { requiresAuth: true },
    component: () => import('../views/dashboard/Settings.vue')
  },
  {
    path: '/dashboard/apps/:id',
    name: 'ViewApp',
    meta: { requiresAuth: true },
    component: () => import('../views/dashboard/ViewApp.vue')
  },
  {
    path: '/dashboard/logout',
    name: 'Logout',
    meta: { requiresAuth: true },
    component: () => import('../views/dashboard/Logout.vue')
  },
  {
    path: '/admin',
    name: 'AdminHome',
    meta: { requiresAuth: true, requiresAdmin: true },
    component: () => import('../views/admin/AdminHome.vue')
  },
  {
    path: '/admin/users',
    name: 'AdminUsers',
    meta: { requiresAuth: true, requiresAdmin: true },
    component: () => import('../views/admin/Users.vue')
  },
  {
    path: '/admin/apps',
    name: 'AdminApps',
    meta: { requiresAuth: true, requiresAdmin: true },
    component: () => import('../views/admin/Apps.vue')
  },
  {
    path: '/admin/licenses',
    name: 'AdminLicenses',
    meta: { requiresAuth: true, requiresAdmin: true },
    component: () => import('@/views/admin/Licenses.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
